import { toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, SecureRoute, Security } from '@okta/okta-react';
import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom/cjs/react-router-dom';
import App from '../App';
import { oktaAuth } from '../utils/okta-config';
import { ROUTE_APP_HOME, ROUTE_FOM, ROUTE_OKTA_CALLBACK } from '../constants/constants';

class SecurityRouter extends Component {

  constructor(props) {
    super();

    oktaAuth.tokenManager.on('error!!!!!!!!', (err) => {
      console.log('Error in okta !!!!:', err);
      window.open(`${window.location.origin}/`, '_self');
    });

    this.restoreOriginalUri = (_oktaAuth, originalUri) => {
      this.props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    }
  }

  render() {
    return (
      <Security
        oktaAuth={oktaAuth}
        restoreOriginalUri={this.restoreOriginalUri}>
        <Switch>
          <Route path={ROUTE_OKTA_CALLBACK} component={LoginCallback} />
          <Route exact path={ROUTE_APP_HOME} render={()=><Redirect to={ROUTE_FOM} />} />
          <SecureRoute path={ROUTE_FOM} component={App} />
        </Switch>
      </Security>
    );
  }
}

export default withRouter(SecurityRouter)